import {
  createGuestEvaluationsApi,
  GUEST_EVALUATION_TOKEN_KEY,
  GUEST_EVALUATION_TOKEN_MAP_KEY,
} from '@waedo/frontend-core/guest-evaluations';

export type {
  GuestSessionResponse,
  GuestSubmitContext,
  GuestSubmitMode,
} from '@waedo/frontend-core/guest-evaluations';
export { GUEST_EVALUATION_TOKEN_KEY, GUEST_EVALUATION_TOKEN_MAP_KEY };

export const {
  clearStoredGuestTokenForCredentials,
  fetchGuestSession,
  getStoredGuestTokenForCredentials,
  storeGuestTokenForCredentials,
  submitGuestEvaluation,
  verifyGuestAccess,
} = createGuestEvaluationsApi({
  getApiBaseUrl: () => import.meta.env.VITE_AI_API_URL?.toString() || '',
  getApiKey: () => import.meta.env.VITE_AI_API_KEY?.toString(),
  getSessionStorage: () => sessionStorage,
});
